<template>
    <div class="activity-content auto-rebalance-success">
        <div class="activity-header">
            <span class="material-icons success-icon">account_balance_wallet</span>
            <div class="activity-title">Otomatik Bakiye Yükleme Başarılı</div>
        </div>
        <div class="activity-details">
            <div class="detail-item">
                <span class="label">Yüklenen Tutar:</span>
                <span class="value success">{{ formatPrice(activity.payload.rechargeAmount) }} TL</span>
            </div>
            <div class="detail-item">
                <span class="label">Önceki Bakiye:</span>
                <span class="value">{{ formatPrice(activity.payload.oldAmount) }} TL</span>
            </div>
            <div class="detail-item">
                <span class="label">Yeni Bakiye:</span>
                <span class="value">{{ formatPrice(activity.payload.newAmount) }} TL</span>
            </div>
            <div class="detail-item">
                <span class="label">Hedef Bakiye:</span>
                <span class="value">{{ formatPrice(activity.payload.upTo) }} TL</span>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "AutoRebalanceSuccess",
    props: {
        activity: {
            type: Object,
            required: true,
        },
    },
    methods: {
        formatPrice(price) {
            if (!price) return "0.00";
            return price.toFixed(2);
        },
    },
};
</script>

<style scoped lang="scss">
.auto-rebalance-success {
    .activity-header {
        display: flex;
        align-items: center;
        gap: 8px;
        margin-bottom: 12px;

        .success-icon {
            color: #52c41a;
            font-size: 20px;
        }

        .activity-title {
            font-weight: 600;
            color: #52c41a;
            font-size: 14px;
        }
    }

    .activity-details {
        display: flex;
        flex-direction: column;
        gap: 6px;
        padding-left: 28px;

        .detail-item {
            display: flex;
            justify-content: space-between;
            font-size: 13px;

            .label {
                color: #666;
            }

            .value {
                font-weight: 500;
                color: #333;

                &.success {
                    color: #52c41a;
                    font-weight: 600;
                }
            }
        }
    }
}
</style>
